import { dbsKeys } from "data/dbsKeys";
import { generateId, readCollection, writeCollection } from "data/dbsStorage";

const EMPTY = [];

export const dealsRepo = {
  list() {
    return readCollection(dbsKeys.deals, EMPTY);
  },

  getById(id) {
    return dealsRepo.list().find((d) => d.id === id) || null;
  },

  create(deal) {
    const items = dealsRepo.list();
    const nextDeal = { ...deal, id: deal.id || generateId("deal") };
    const next = [nextDeal, ...items];
    writeCollection(dbsKeys.deals, next);
    return nextDeal;
  },

  update(id, patch) {
    const items = dealsRepo.list();
    const next = items.map((d) => (d.id === id ? { ...d, ...patch, id: d.id } : d));
    writeCollection(dbsKeys.deals, next);
    return next.find((d) => d.id === id) || null;
  },

  remove(id) {
    const items = dealsRepo.list();
    const next = items.filter((d) => d.id !== id);
    writeCollection(dbsKeys.deals, next);
  },
};
